export const TOKEN_KEY = 'TOKENS'

/**
 * @description This function is here for migration purposes.
 * We used to call `apiToken` by `token` and it would create problems in which we couldn't identify what `token` was referring to.
 * Users have those tokens stored in localStorage and we don't know when we will stop having those.
 * In order to ensure that this won't break for existing users, we can migrate those tokens on the fly when a user accesses it.
 * @param {Object} tokens A user's tokens
 * @return {Object}
 */
function migrateTokens(tokens) {
  const { token, ...rest } = tokens

  if (token !== undefined) {
    const newTokens = {
      ...rest,
      apiToken: token,
    }
    storeTokens(newTokens)
    return newTokens
  }

  return tokens
}

export function recoverTokens() {
  const rawTokens = localStorage.getItem(TOKEN_KEY)
  if (!rawTokens) {
    return null
  }

  const tokens = JSON.parse(rawTokens)

  return migrateTokens(tokens)
}

export function storeTokens(tokens) {
  localStorage.setItem(
    TOKEN_KEY,
    JSON.stringify({
      ...tokens,
      at: Date.now(),
    })
  )
}

export function clearTokens() {
  localStorage.removeItem(TOKEN_KEY)
}
